import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ListaPaginada, TrechoRodoviario } from "../../../model";
import { API } from "../../../app.config";

@Injectable({
    providedIn: "root",
})
export class TrechoService {
    constructor(private http: HttpClient) {}

    getAll(valor: string): Observable<ListaPaginada<TrechoRodoviario>> {
        valor = encodeURIComponent(valor);
        return this.http.get<ListaPaginada<TrechoRodoviario>>(`${API}/api/trechorodoviario/list?q=${valor}`);
    }

    post(trecho: TrechoRodoviario): Observable<TrechoRodoviario> {
        return this.http.post<TrechoRodoviario>(`${API}/api/trechorodoviario`, trecho);
    }

    put(trecho: TrechoRodoviario): Observable<TrechoRodoviario> {
        return this.http.put<TrechoRodoviario>(`${API}/api/trechorodoviario/${trecho.Id}`, trecho);
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${API}/api/trechorodoviario/${id}`);
    }
}
